import React from "react";
import Helmet from "react-helmet";
import Main from "../../components/main";
import Box from "../../components/box";
import H1 from "../../components/h1";
import P from "../../components/p";
import A from "../../components/a";

const ContactUs = () => (
  <Main>
    <Helmet>
      <title>Contact Us | Ghast</title>
      <meta
        name="description"
        content="If you want to hear from us, please feel free to use the live chat, we will do our best to get back to you immediately"
      />
    </Helmet>
    <Box>
      <H1>Contact Us</H1>
      <P>
        Hi guys, if you want to get in contact with us, feel free to email
        support@ghast.io or use our live chat in the bottom right corner of the
        screen, you can also join our{" "}
        <A href="http://discord.ghast.io">discord server</A>! If you want to
        discuss something that is not directly related to Ghast, you can contact
        the parent company AuraSide, Inc. by calling +1 (650) 337 0808.
      </P>
    </Box>
  </Main>
);

export default ContactUs;



/** WEBPACK FOOTER **
 ** ./src/views/pages/contact-us/index.js
 **/